// components/PayYourWay/PayYourWay.jsx
import React from 'react';
import css from './PayYourWay.module.css';
import IconCard from '../SavedCardDetails/IconCard/IconCard';
import classNames from 'classnames';

const features = [
  {
    id: 1,
    title: 'Flexible Installments',
    description: 'Pay in 3 or 4 installments based on eligibility.',
    icon: 'Flexible',
  },
  {
    id: 2,
    title: 'Start Learning Today',
    description: 'Available on eligible training programs',
    icon: 'LearningToday',
  },
  {
    id: 3,
    title: 'Quick & Secure Checkout',
    description: 'Safe and seamless payments powered by Stripe.',
    icon: 'SecureCheckout',
  },
];

const PayYourWay = ({ listingPage }) => {
  return (
    <section className={classNames(css.payYourWay, listingPage && css.payYourWayListing)} aria-labelledby="pay-your-way-title">
      <div className={css.container}>
        {/* ===== Left Content ===== */}
        <div className={css.leftContent}>
          <span className={css.tag}>PAY YOUR WAY</span>

          <h2 id="pay-your-way-title" className={css.title}>
            <span>Split your payment into </span> 3 or 4 installments
          </h2>

          <p className={css.description}>
            Spread the cost of your training with flexible installment options. Pay in 3 or 4
            installments, depending on your eligibility.
          </p>

          <ul className={css.featuresList}>
            {features.map(feature => (
              <li
                key={feature.id}
                className={classNames(css.featureItem, listingPage && css.featureItemListing)}
              >
                <span className={css.featureIconWrapper} aria-hidden="true">
                  <IconCard brand={feature.icon} />
                </span>
                <div className={css.featureText}>
                  <h3 className={css.featureTitle}>{feature.title}</h3>
                  <p className={css.featureDescription}>{feature.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        {/* ===== Divider ===== */}
        <div className={css.divider} aria-hidden="true" />

        {/* ===== Right Content ===== */}
        <div className={css.rightContent}>
          <div className={css.rightTop}>
            <p className={css.installmentsLabel}>Pay in installments with</p>

            <div className={css.scalapayWrapper}>
              <div className={css.scalapayBadge}>
                <IconCard brand="scalapay" />
              </div>
            </div>
          </div>

          <p className={css.disclaimer}>
            <IconCard brand="exclamationCircle" />
            Available on eligible training programs. Installment options may vary based on customer
            eligibility and course value.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PayYourWay;
